import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue"

export function render(_ctx, _cache) {
  const _component_crumbs_h1 = _resolveComponent("crumbs-h1")
  const _component_crumbs_p = _resolveComponent("crumbs-p")
  const _component_timer_component = _resolveComponent("timer-component")
  const _component_line_component = _resolveComponent("line-component")
  const _component_turn_component = _resolveComponent("turn-component")
  const _component_intersection_component = _resolveComponent("intersection-component")
  const _component_cross_component = _resolveComponent("cross-component")
  const _component_crumbs_button = _resolveComponent("crumbs-button")
  const _component_crumbs_panel = _resolveComponent("crumbs-panel")

  return (_openBlock(), _createBlock(_component_crumbs_panel, null, {
    default: _withCtx(() => [
      _createVNode(_component_crumbs_h1, null, {
        default: _withCtx(() => [
          _createTextVNode(" Cheminot ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_crumbs_p, null, {
        default: _withCtx(() => [
          _createTextVNode(" Fermez le chemin de fer en orientant les rails. ")
        ]),
        _: 1 /* STABLE */
      }),
      _createVNode(_component_timer_component),
      _createElementVNode("div", {
        class: "playground",
        style: _normalizeStyle(`width: clamp(10rem, 60vh, 40rem); height: clamp(10rem, 60vh, 40rem); display: grid; grid-template-columns: repeat(${ _ctx.puzzle().block.w }, 1fr); grid-template-rows: repeat(${ _ctx.puzzle().block.h }, 1fr);`)
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle().lines, (line) => {
          return (_openBlock(), _createBlock(_component_line_component, {
            style: _normalizeStyle(`grid-area: ${line.block.y+1}/${line.block.x+1}/${line.block.y + line.block.h+1}/${line.block.x + line.block.w+1}`),
            id: line.id
          }, null, 8 /* PROPS */, ["style", "id"]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle().turns, (turn) => {
          return (_openBlock(), _createBlock(_component_turn_component, {
            style: _normalizeStyle(`grid-area: ${turn.block.y+1}/${turn.block.x+1}/${turn.block.y + turn.block.h+1}/${turn.block.x + turn.block.w+1}`),
            id: turn.id
          }, null, 8 /* PROPS */, ["style", "id"]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle().intersections, (intersection) => {
          return (_openBlock(), _createBlock(_component_intersection_component, {
            style: _normalizeStyle(`grid-area: ${intersection.block.y+1}/${intersection.block.x+1}/${intersection.block.y + intersection.block.h+1}/${intersection.block.x + intersection.block.w+1}`),
            id: intersection.id
          }, null, 8 /* PROPS */, ["style", "id"]))
        }), 256 /* UNKEYED_FRAGMENT */)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.puzzle().crosses, (cross) => {
          return (_openBlock(), _createBlock(_component_cross_component, {
            style: _normalizeStyle(`grid-area: ${cross.block.y+1}/${cross.block.x+1}/${cross.block.y + cross.block.h+1}/${cross.block.x + cross.block.w+1}`),
            id: cross.id
          }, null, 8 /* PROPS */, ["style", "id"]))
        }), 256 /* UNKEYED_FRAGMENT */))
      ], 4 /* STYLE */),
      (_ctx.lost)
        ? (_openBlock(), _createElementBlock("div", { key: 0 }, [
            _createVNode(_component_crumbs_p, { style: {"text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode(" 😢 Partie perdue - Temps écoulé! ⏱️ ")
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true),
      (_ctx.win && !_ctx.lost)
        ? (_openBlock(), _createElementBlock("div", { key: 1 }, [
            _createVNode(_component_crumbs_p, { style: {"text-align":"center"} }, {
              default: _withCtx(() => [
                _createTextVNode(" 🎉 C'est gagné pour aujourd'hui ! 🥳 "),
                _createElementVNode("br"),
                _createVNode(_component_crumbs_button, {
                  title: "Copier dans le presse-papier",
                  onClick: $event => (_ctx.share())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Partager ")
                  ]),
                  _: 1 /* STABLE */
                }, 8 /* PROPS */, ["onClick"])
              ]),
              _: 1 /* STABLE */
            })
          ]))
        : _createCommentVNode("v-if", true)
    ]),
    _: 1 /* STABLE */
  }))
}